import { useEffect, useState } from 'react';
import {
  getDeferredPrompt,
  isAppInstalledFlag,
  isStandalone,
  subscribeInstallPrompt,
  triggerInstall,
} from '@/lib/installPrompt';

export function useInstallPrompt() {
  const [canInstall, setCanInstall] = useState(() => !!getDeferredPrompt());
  const [installed, setInstalled] = useState(() => isAppInstalledFlag() || isStandalone());

  useEffect(() => {
    const sync = () => {
      setCanInstall(!!getDeferredPrompt());
      setInstalled(isAppInstalledFlag() || isStandalone());
    };
    sync();
    return subscribeInstallPrompt(sync);
  }, []);

  return { canInstall, installed, install: triggerInstall };
}
